"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
var _Popover = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Popover"));
var _Menu = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Menu"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var MoreIcon = function MoreIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 17a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm0-6.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zM12 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z"
  }));
};
MoreIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var styles = {
  "actions": "actions_1N6To7",
  "action": "action_183fJR",
  "menu": "menu_2p9zaV"
}; 
require('./Actions.css');
var renderMenuFcn = function renderMenuFcn(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react.default.createElement(_Menu.default, {
    className: styles.menu
  }, children);
};
var Actions = function Actions(_ref2) {
  var children = _ref2.children,
    _ref2$onClose = _ref2.onClose,
    onClose = _ref2$onClose === void 0 ? function () {} : _ref2$onClose,
    _ref2$onOpen = _ref2.onOpen,
    onOpen = _ref2$onOpen === void 0 ? function () {} : _ref2$onOpen,
    _ref2$renderMenu = _ref2.renderMenu,
    renderMenu = _ref2$renderMenu === void 0 ? renderMenuFcn : _ref2$renderMenu,
    _ref2$offset = _ref2.offset,
    offset = _ref2$offset === void 0 ? [0, 0] : _ref2$offset;
  var popoverContainerRef = (0, _react.useRef)(null);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: styles.actions,
    ref: popoverContainerRef
  }, /*#__PURE__*/_react.default.createElement(_Popover.default, {
    getPopoverContainer: function getPopoverContainer() {
      return popoverContainerRef.current;
    },
    testId: "versions-table-actions",
    anchorPosition: "br",
    popupPosition: "tr",
    triggerOn: ['click'],
    offset: offset,
    onOpen: onOpen,
    onClose: onClose,
    content: renderMenu({
      children: children
    })
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: styles.action
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    role: "img",
    "aria-label": "Show actions",
    size: "s",
    "data-test-id": "show-actions-icon"
  }, /*#__PURE__*/_react.default.createElement(MoreIcon, null)))));
};
var _default = exports.default = Actions;
//# sourceMappingURL=Actions.js.map